/**
 * The LicencesReport model shows the maximum available licences for storage, streaming and credits .
 */

export interface LicencesReport {
    maxprocessing: number;
    maxstorage: number;
    maxtransfer: number;
}
